<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">BORN TO RULE</h1>
<p class="title">FIVE REIGNING CONSORTS, GRANDDAUGHTERS OF QUEEN VICTORIA</p>
<h2 class="author">JULIA P. GELARDI</h2>
<p class="center"><img alt="" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?4f8fb305